/**
 * Debug utility for development
 * Only logs in development mode
 */

const isDevelopment = import.meta.env.DEV;

/**
 * Debug logger - only logs in development
 */
export function debugLog(...args: any[]): void {
	if (isDevelopment) {
		console.log(...args);
	}
}

/**
 * Debug warn - only logs in development
 */
export function debugWarn(...args: any[]): void {
	if (isDevelopment) {
		console.warn(...args);
	}
}

/**
 * Debug error - always logs (errors should be visible)
 */
export function debugError(...args: any[]): void {
	console.error(...args);
}
